import React from "react";
import {PiRocket} from "react-icons/pi";

export function Footer() {


    return(
      <div className={"bg-dark p-5 py-3 d-none"}>
        <div className={"row text-white"}>
            <div className={"col d-flex align-items-center"}>
                <PiRocket size={24} className={"me-2"}/>
                <h4 className={"p-0 m-0"}>Karakterboost</h4>
            </div>
            <div className={"col-2 d-flex align-items-center justify-content-center"}>
                <p> &copy; 2025 Karakterboost AS. </p>
            </div>
        </div>
      </div>
    );


}